<template>
  <div class="flex flex-col">
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        文章列表
      </div>
      <div class="flex flex-row-reverse">
        <el-button type="primary" @click="goAddNews">添加文章</el-button>
      </div>
      <div class=" mt-6">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column fixed prop="news_title" label="标题" width="150">
          </el-table-column>
          <el-table-column prop="news_type" label="类型" width="120">
          </el-table-column>

          <el-table-column prop="add_time" label="添加时间" width="120">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >
              <el-button type="text" size="small" @click="updateNews(scope.row)"
                >编辑</el-button
              >

              <el-button type="text" size="small" @click="deleteNews(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="mt-6"

                       @current-change="handleCurrentChange"
                       :current-page.sync="pageQuantity"
                       background
                       :page-size="pageCount"
                       layout="total, prev, pager, next"
                       :total="pagesCount">
        </el-pagination>


      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      pageQuantity:1,
      pageCount:6,
      pagesCount:'',
    };
  },
  mounted() {

    this.getNews(this.pageQuantity,this.pageCount);
  },
  methods: {
    handleCurrentChange(val) {
      this.getNews(val,this.pageCount)
    },
    //获取数据
    getNews(pageQuantity,pageCount) {
      axios.get(`/selectNews?pageQuantity=${pageQuantity}&pageCount=${pageCount}`).then(({ data }) => {

        if (data.code == 200) {
          this.tableData = data.data;
          this.pagesCount = data.pagesCount
        }
      });
    },

    handleClick(row) {
      this.$router.push({
        path: "/newsContent",
        query: { news_id: row.news_id }
      });
    },
    goAddNews() {
      this.$router.push("/news");
    },
    updateNews(row) {
      this.$router.push({path:"/updateNews",query:{news_id: row.news_id}});
    },

    deleteNews(row) {
      this.$confirm("此操作将永久删除该文档, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios.delete("/deleteNews_id/" + row.news_id).then(({ data }) => {
            if (data.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.getNews();
            }
          });

        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },


};
</script>



// WEBPACK FOOTER //
// src/views/news/NewsList.vue